function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5559 5.68982L25.7394 5.875H26H46.8C49.3092 5.875 51.375 7.95203 51.375 10.5V36.75C51.375 39.298 49.3092 41.375 46.8 41.375H5.2C2.6908 41.375 0.625 39.298 0.625 36.75L0.651 5.25052V5.25C0.651 2.69792 2.69485 0.625 5.2 0.625H18.642C19.8521 0.625 21.0185 1.10877 21.8899 1.98857L25.5559 5.68982Z",
  stroke: "url(#paint0_linear)",
  strokeWidth: 1.25
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 26,
  y1: 63,
  x2: 67.06,
  y2: 12.1638,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#501F99",
  id: "primary_stop_color"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3247C",
  id: "secondary_stop_color"
})));
const SvgFoldersIcons = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFoldersIcons, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/foldersIcons.db0d1761.svg";
export { ForwardRef as ReactComponent };